import { render, staticRenderFns } from "./DestinationVideo.vue?vue&type=template&id=358bdb85&scoped=true"
import script from "./DestinationVideo.vue?vue&type=script&lang=js"
export * from "./DestinationVideo.vue?vue&type=script&lang=js"
import style0 from "./DestinationVideo.vue?vue&type=style&index=0&id=358bdb85&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358bdb85",
  null
  
)

export default component.exports